import { render, staticRenderFns } from "./report-tizhi.vue?vue&type=template&id=56dfffc2&scoped=true&"
import script from "./report-tizhi.vue?vue&type=script&lang=ts&"
export * from "./report-tizhi.vue?vue&type=script&lang=ts&"
import style0 from "./report-tizhi.vue?vue&type=style&index=0&id=56dfffc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dfffc2",
  null
  
)

export default component.exports